import { Injectable } from '@angular/core';
import { LocalizationService } from 'abp-ng2-module';
import { AppSessionService } from '../session/app-session.service';

@Injectable({ providedIn: 'root' })
export class CashierAssignmentCheckService {
  constructor(
    private _sessionService: AppSessionService,
    private _localization: LocalizationService
  ) {}

  ensureAssignedOrWarn(): boolean {
    if (this._sessionService.user.cashierConfigId != null) {
      return true;
    }

    abp.message.error(this._localization.localize('NoCashierAssigned', 'PosMaer'));
    return false;
  }
}
